'use client';

import PerfBarChart, { type PerfBar } from './PerfBarChart';

const data: PerfBar[] = [
  { label: 'Eigen', value: 0.232, valueLabel: '0.232x', color: 'gray' },
  { label: 'inline GEMM', value: 0.879, valueLabel: '0.879x', color: 'gray' },
  { label: 'A2 fast path', value: 1.335, valueLabel: '1.335x', color: 'gray' },
  { label: 'C engine', value: 1.6, valueLabel: '1.6x', color: 'yellow' },
];

export default function A2RtfDaisy() {
  return (
    <PerfBarChart
      headerTitle="Embedded Inference Speed"
      headerDescription="Whether A2-Lite can run in real time directly on resource-constrained embedded hardware."
      title="A2-Lite inference on the Daisy (Cortex-M7, 480 MHz)"
      subtitle="48-sample buffer @ 48 kHz, averaged over 100 buffers. A real-time factor above 1.0 means the model runs in real time with margin to spare."
      data={data}
      yAxisTitle="Real-time factor (>1 = runs in real time)"
      yMax={1.8}
      referenceLine={{ value: 1, label: 'real-time' }}
    />
  );
}
